<template>
  <div class="slgfhsitem">
    <div
      v-if="$store?.getters?.user_has_flag?.('SOL_3WAY')"
      class="slgfhsitem_players text-nowrap"
      v-html="
        item.custom_tree.players
          .map(p => getPlayerHtmlPosition(p.display_position))
          .join($t('solfigr.vs'))
      "
    ></div>
    <div
      v-else
      class="slgfhsitem_players text-nowrap"
      v-html="
        $t(`solfigr.oop_vs_ip`, {
          oop: getPlayerHtmlPosition(item.custom_tree.players[0].display_position),
          ip: getPlayerHtmlPosition(item.custom_tree.players[1].display_position),
        })
      "
    ></div>
    <CardRowSimple
      class="slgfhsitem_board"
      :cards="getCards(item.board)"
      style="
        --crds-card-height: var(--hsi-card-height);
        --crds-card-value-size-increase: var(--hsi-card-value-size-increase);
      "
    />
    <div
      v-if="item.node_locks_count"
      class="slgfhsitem_locks f-center"
    >
      <div class="mdi mdi-lock slgfhsitem_locks_icon"></div>
      <div class="text-small weight_600">
        {{ item.node_locks_count }}
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import CardRowSimple from '@/components/CardRow/CardRowSimple'
import float_mix from '@/mixins/float_mix'
import format_mix from '@/mixins/format_mix'

export default {
  name: 'SolfigrHistoryItem',
  components: {
    CardRowSimple,
  },
  mixins: [format_mix, float_mix],
  props: {
    item: { Object, required: true },
  },
}
</script>

<style lang="scss" scoped>
.slgfhsitem {
  display: flex;
  --min-width-players: 6rem;
  --hsi-card-height: 1.8rem;
  --hsi-card-value-size-increase: 0.9;
  &_locks {
    margin: 0 0 0 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    // &_icon {
    // font-size: 1.125em;
    // }
  }
  &_players {
    margin: 0 0.75rem 0 0;
    min-width: var(--min-width-players);
    font-size: clamp(8px, 0.875rem, clamp(1px, 0.875rem, 2vw));
  }
}
</style>
